import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import pages from "./pages.json";

export const SITE_URL = "https://teledyne.ma";
export const normalizePath = (path) => path.replace(/\/+$/, "") || "/";

export default function PageSeo() {
  const { pathname } = useLocation();
  const path = normalizePath(pathname);
  const key = Object.keys(pages).find((candidate) => candidate.toLowerCase() === path.toLowerCase());
  const page = pages[key] || pages["/UnderConstruction"];
  const indexable = !!key && !page.noindex;
  const url = SITE_URL + (key || path);
  const organization = {
    "@type": "Organization", "@id": `${SITE_URL}/#organization`,
    name: "TELEDYNE", url: `${SITE_URL}/`, logo: `${SITE_URL}/images/logo.webp`,
    email: "contact@teledyne.ma", telephone: "+212522307664",
    address: {
      "@type": "PostalAddress", streetAddress: "2, rue Abdelouhab Azzakkak, Roches Noires",
      addressLocality: "Casablanca", postalCode: "20310", addressCountry: "MA",
    },
    contactPoint: [{
      "@type": "ContactPoint", contactType: "customer service", telephone: "+212522307668",
      url: `${SITE_URL}/contactus`,
    }],
  };
  const graph = [organization, {
    "@type": "WebSite", "@id": `${SITE_URL}/#website`, name: "TELEDYNE",
    url: `${SITE_URL}/`, inLanguage: "fr", publisher: { "@id": organization["@id"] },
  }, {
    "@type": "WebPage", "@id": `${url}#webpage`, url, name: page.title,
    description: page.description, inLanguage: "fr",
    isPartOf: { "@id": `${SITE_URL}/#website` },
  }];
  if (indexable && key !== "/") {
    const section = key.startsWith("/services/") ? "/services" : key.startsWith("/produits/") ? "/produits" : key.startsWith("/solutions/") ? "/solutions" : null;
    const crumbs = [{ "@type": "ListItem", position: 1, name: "Accueil", item: `${SITE_URL}/` }];
    if (section) crumbs.push({ "@type": "ListItem", position: 2, name: pages[section].label, item: SITE_URL + section });
    crumbs.push({ "@type": "ListItem", position: crumbs.length + 1, name: page.label, item: url });
    graph.push({ "@type": "BreadcrumbList", "@id": `${url}#breadcrumbs`, itemListElement: crumbs });
    if (section === "/services") graph.push({ "@type": "Service", name: page.label, description: page.description, url, provider: { "@id": organization["@id"] } });
  }
  return <Helmet>
    <html lang="fr" />
    {key === "/" && <link rel="preload" as="image" href="/images/home/hero/tracabilite-rfid.webp" fetchpriority="high" />}
    <title>{page.title}</title>
    <meta name="description" content={page.description} />
    <meta name="robots" content={indexable ? "index,follow" : "noindex,follow"} />
    {indexable && <link rel="canonical" href={url} />}
    <meta property="og:type" content="website" />
    <meta property="og:locale" content="fr_FR" />
    <meta property="og:site_name" content="TELEDYNE" />
    <meta property="og:title" content={page.title} />
    <meta property="og:description" content={page.description} />
    <meta property="og:url" content={url} />
    <meta property="og:image" content={`${SITE_URL}/images/share-pic.png`} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={page.title} />
    <meta name="twitter:description" content={page.description} />
    <meta name="twitter:image" content={`${SITE_URL}/images/share-pic.png`} />
    <script type="application/ld+json">{JSON.stringify({ "@context": "https://schema.org", "@graph": graph }).replace(/</g, "\\u003c")}</script>
  </Helmet>;
}
